import { SimpleChange } from '@angular/core';

export type TypedChanges<Component, Props = PickProperties<Component>> = {
  [K in keyof Partial<Props>]: TypedChange<Props[K]>;
};

type PickProperties<T> = Pick<T, Properties<T>>;
type Properties<T> = FilterOutMethods<T>[keyof T];
type FilterOutMethods<T> = {
  [K in keyof T]: T[K] extends (...params: any[]) => any ? never : K;
};

export interface TypedChange<T> extends SimpleChange {
  previousValue: T;
  currentValue: T;
  firstChange: boolean;
  isFirstChange(): boolean;
}
